import { Fragment } from 'react';
import { Listbox, Transition } from '@headlessui/react';
import { CheckIcon, ChevronUpDownIcon } from '@heroicons/react/20/solid';

export default function JustificationProfileListBox({
    profiles = [],
    value = null,
    onChange,
    disabled = false,
    placeholder = 'Seleziona un profilo...',
}) {
    const selected = value || { id: null, name: placeholder };

    return (
        <Listbox
            value={selected}
            onChange={onChange}
            disabled={disabled}
            by="id"
        >
            <div className="relative z-[100] w-full">
                <Listbox.Button
                    className={`relative h-10 w-full rounded-md border border-gray-300 bg-white py-2 pl-3 pr-10 text-left text-sm shadow-sm focus:outline-none focus-visible:border-indigo-500 focus-visible:ring-1 focus-visible:ring-indigo-500 ${
                        disabled ? 'cursor-not-allowed bg-gray-100 text-gray-400 opacity-60' : 'cursor-pointer text-gray-700'
                    }`}
                >
                    <span className="block truncate">
                        {disabled ? 'Salvataggio in corso...' : selected.name}
                    </span>

                    <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                        <ChevronUpDownIcon className="h-5 w-5 text-gray-400" />
                    </span>
                </Listbox.Button>

                <Transition
                    as={Fragment}
                    leave="transition ease-in duration-100"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <Listbox.Options className="absolute left-0 top-full z-[100] mt-1 max-h-60 w-full overflow-auto rounded-md border border-gray-200 bg-white py-1 text-sm shadow-xl ring-1 ring-black/5 focus:outline-none">
                        {profiles.map(profile => {
                            const isAssigned = profile.id === value?.id;

                            return (
                                <Listbox.Option
                                    key={profile.id}
                                    value={profile}
                                    className={({ active }) =>
                                        `relative cursor-pointer select-none py-2 pl-10 pr-4 ${
                                            active ? 'bg-indigo-50 text-indigo-900' : 'text-gray-900'
                                        }`
                                    }
                                >
                                    <div className="flex items-center justify-between gap-3">
                                        <span
                                            className={`block min-w-0 truncate ${
                                                isAssigned
                                                    ? 'font-semibold text-indigo-800'
                                                    : 'font-normal'
                                            }`}
                                        >
                                            {profile.name}
                                        </span>

                                        {isAssigned && (
                                            <span className="shrink-0 text-[10px] font-semibold uppercase tracking-wide text-indigo-600">
                                                Assegnato
                                            </span>
                                        )}
                                    </div>

                                    {isAssigned && (
                                        <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-indigo-600">
                                            <CheckIcon className="h-5 w-5" />
                                        </span>
                                    )}
                                </Listbox.Option>
                            );
                        })}
                    </Listbox.Options>
                </Transition>
            </div>
        </Listbox>
    );
}